export const appConfig = {
    webUrlBasePath: "http://localhost:5000",
    apiUrlBasePath: "http://localhost:3000/api",
    factoryLogo: "https://funfigz-assets-public.s3.ap-south-1.amazonaws.com/product-logo.png",
}